import { cardDefinitions } from './cardDefinitions.generated';

const byId = new Map(cardDefinitions.map((d) => [d.id, d]));

export function getDefinition(definitionId) {
  const def = byId.get(definitionId);
  if (!def) throw new Error(`Unknown card definition id: ${definitionId}`);
  return def;
}

// Most instances are plain { definitionId } and resolve straight to the
// shared definition object. A few effects need a *specific physical copy* to
// have a stat that diverges from its definition for the rest of the game
// (e.g. Belac gaining Health, Drakeclan Laird's Health-equal-to-other-kobolds)
// - those are stored as extra keys on the instance and merged in here, so
// every other piece of code that reads a card's stats/traits automatically
// sees the overridden value without needing to know overrides exist.
export function getInstanceDefinition(state, instanceId) {
  const instance = state.instances[instanceId];
  if (!instance) throw new Error(`Unknown card instance id: ${instanceId}`);
  const def = getDefinition(instance.definitionId);
  // eslint-disable-next-line no-unused-vars -- destructured only to exclude it from `overrides`
  const { definitionId, ...overrides } = instance;
  return Object.keys(overrides).length ? { ...def, ...overrides } : def;
}
